import styled from '@emotion/styled';

export const IconWrapper = styled.p`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 24px;
  line-height: 22px;
  color: #878787;
  cursor: pointer;
`;